import { render } from "./TransportOffersView.vue?vue&type=template&id=627a9e61"
import script from "./TransportOffersView.vue?vue&type=script&lang=js"
export * from "./TransportOffersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__